<ion-app>
  <app-splash *ngIf="showSplash">

  </app-splash>

  <ion-header id="impersonation-notice" *ngIf="shouldDisplayImpersonationBanner">
    <ion-text>You are accessing agent {{impersonatingUserEmail}}</ion-text>
    <ion-button fill="outline" color="dark" size="small" (click)="removeImpersonation()">Return to your
      account</ion-button>
  </ion-header>

  <!-- If we are showing the impersonation banner push down the app content so that it doesn't cover everything -->
  <ion-split-pane contentId="main-content" class="full-height"
    [style.margin-top]="shouldDisplayImpersonationBanner ? '40px' : '0px'">

    <ion-menu class="side-menu-gradient full-height" contentId="main-content" type="overlay"
      [style.padding-bottom.px]="utils.keyboardHeight">
      <ion-content class="full-height">
        <div class="centerAlign">
          <img class="menuLogo" src="assets/imgs/signUpLogo.png" data-cy="homeScreen-menu-logo">
        </div>

        <div class="spacer-10"></div>

        <div class="qrCodeWrapper" *ngIf="userData?.role !== 'agentAdmin'">
          <!-- QR CODE DOES NOT EXIST -->

          <div *ngIf="!qrCodeImageData" class="link" [ngClass]="isQRCodeAvailable"
            data-cy="homeScreen-menu-qr-code-not-available">
            <div class="qr-content-overlay" (click)="goToOnlylink($event)"></div>

            <div class="qr-content" (click)="goToOnlylink($event)">
              <img src="assets/imgs/qrcode_sample.png">
            </div>

            <div class="floating-action-button link buttonIcon" *ngIf="isQRCodeAvailable==='qr-code-disabled'"
              (click)="goToOnlylink($event)">
              <span title="Create Dynamic QR Code" alt="Create Dynamic QR Code">
                <ion-icon name="add-sharp" class="noTooltip"></ion-icon>
              </span>
            </div>
          </div>

          <!-- QR CODE EXISTS -->
          <div *ngIf="qrCodeImageData && isQRCodeAvailable" [ngClass]="isQRCodeAvailable"
            data-cy="homeScreen-menu-qr-code-available">
            <div class="qr-content-overlay"></div>
            <div class="qr-content link" (click)="openYourQRCode($event)" data-cy="homeScreen-menu-div-dynamic-qr-code">
              <ion-img *ngIf="qrCodeImageData" [src]="qrCodeImageData" alt="Dynamic QR Code" title="Dynamic QR Code"
                data-cy="homeScreen-menu-img-dynamic-qr-code"></ion-img>
            </div>
          </div>

        </div>

        <div class="spacer-10"></div>
        <div class="dividerLine"></div>

        <div *ngIf="isLoggedIn" class="menuWrapper">
          <ion-menu-toggle auto-hide="false" *ngFor="let p of pages; let i = index">
            <div class="link" (click)="navigationClick(p)">
              <ion-item class="mainMenuItem" routerDirection="root" side="start" [routerLink]="[p.url]" lines="none"
                detail="false" routerLinkActive="selected" [disabled]="!p.enabled">
                <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-outline'"
                  [attr.data-cy]="'homeScreen-menu-' + p.url.replace('/', '') + '-icon'"> </ion-icon>
                <ion-label class="margin-left-5" [attr.data-cy]="'homeScreen-menu-' + p.url.replace('/', '') + '-txt'">
                  {{
                  p.title }}</ion-label>
              </ion-item>
            </div>
          </ion-menu-toggle>
        </div>

        <div class="subscribeMenuItem">
          <ion-item (click)="openPage('MySubscriptionPage');" class="link" lines="none"
            *ngIf="!cordova && isLoggedIn && userData?.role === 'lender'">
            <ion-icon slot="start" name="card-outline"> </ion-icon>
            <ion-label class="margin-left-5"> Subscription</ion-label>
          </ion-item>

          <ion-item (click)="openPage('MySubscriptionPage');" class="link" lines="none"
            *ngIf="!cordova && isLoggedIn && userData?.role === 'agentAdmin'">
            <ion-icon slot="start" name="card-outline" data-cy="homeScreen-menu-subscription-icon"> </ion-icon>
            <ion-label class="margin-left-5" data-cy="homeScreen-menu-subscription-txt">Subscription</ion-label>
          </ion-item>
        </div>

        <div class="shareAndEarn" *ngIf="showShare && userData?.role === 'agent'">
          <div class="dividerLine"></div>
          <p class="mainMenuItem"> Share & Earn
            <span class="link" (click)="referralInfoText()">
              <ion-icon slot="icon-only" name="information-circle" class="link noTooltip"></ion-icon>
            </span>
          </p>
          <ion-row class="link-border" *ngIf="!showReferralButton">
            <ion-col [size]="10">
              <p (click)="copyReferralCode()" class="linkURL link">{{referralLink}}</p>
            </ion-col>
            <ion-col [size]="2">
              <span class="info-span link" (click)="copyReferralCode()">
                <ion-icon class="copy-icon link noTooltip" name="copy-outline" slot="icon-only"></ion-icon>
              </span>
            </ion-col>
          </ion-row>
          <p *ngIf="showReferralButton" class="subtitle"> Get paid to share our free app! </p>
          <ion-button class="join-referral-btn" *ngIf="showReferralButton" color="light"
            (click)="joinReferralProgram()"> Join
            Referral Program </ion-button>
        </div>
        <div class="spacer-10"></div>
        <div class="termsAndCond">
          <!--
          <div class="link" (click)="terms()">Terms of Use</div>
          <div class="link" (click)="privacy()">Privacy Policy</div>
          -->
          <ion-item (click)="terms()" class="mainMenuItem link" side="start" lines="none">
            <ion-label class="margin-left-5" data-cy="homeScreen-menu-termsOfUse-txt"> Terms of Use</ion-label>
          </ion-item>

          <ion-item (click)="privacy()" class="mainMenuItem link" side="start" lines="none">
            <ion-label class="margin-left-5" data-cy="homeScreen-menu-privacyPolicy-txt"> Privacy Policy</ion-label>
          </ion-item>
        </div>

      </ion-content>

    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>